import React, { useState } from 'react';
import axios from 'axios';
import './CreateTeam.css'; // Ensure the CSS file is correctly linked

function CreateTeam({ userId }) {
    const [teamName, setTeamName] = useState('');
    const [message, setMessage] = useState('');

    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            const response = await axios.post('http://localhost:3001/api/teams', { name: teamName, userId });
            setMessage(response.data.message);
            setTeamName('');
        } catch (error) {
            console.error('Error creating team:', error);
            setMessage('Error creating team');
        }
    };

    return (
        <div className="create-team-container">
            <h2>Create a Team</h2>
            <form onSubmit={handleSubmit}>
                <label>
                    Team Name:
                    <input
                        type="text"
                        value={teamName}
                        onChange={(e) => setTeamName(e.target.value)}
                        required
                    />
                </label>
                <button type="submit">Create Team</button>
            </form>
            {message && <p>{message}</p>}
        </div>
    );
}

export default CreateTeam;
